import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import BodyContentType from 'owa-service/lib/contract/BodyContentType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import emailAddressWrapperToAttendeeType from '../../utils/emailAddressWrapperToAttendeeType';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import {
    createEnhancedLocationsFromPersonaControlViewState,
    createLocationPersonaFromStringLocation,
} from 'owa-location-persona';
import popoutCalendarCompose, {
    SerializableCalendarEvent,
} from 'owa-popout-utils/lib/utils/popoutCalendarCompose';
import { AddPopoutSource } from 'owa-popout-v2';

export const displayNewAppointmentForm = (
    requiredAttendees?: EmailAddressWrapper[],
    optionalAttendees?: EmailAddressWrapper[],
    start?: number,
    end?: number,
    location?: string,
    resources?: string[],
    subject?: string,
    body?: string
) => {
    const required = emailAddressWrapperToAttendeeType(requiredAttendees);
    const optional = emailAddressWrapperToAttendeeType(optionalAttendees);

    // For start and end, 0 means the Unix epoch.
    // For start, null/undefined becomes "now".
    // For end, null/undefined becomes undefined so it is not sent.
    const startTime = new Date(start == void 0 ? Date.now() : start);
    const endTime = end == void 0 ? undefined : new Date(end);

    let enhancedLocation: EnhancedLocation;
    if (location) {
        const viewstate = createLocationPersonaFromStringLocation(location);
        enhancedLocation = createEnhancedLocationsFromPersonaControlViewState(viewstate)[0];
    }

    const convertedResources = resources
        ? resources.map(res => {
              return <AttendeeType>{
                  Mailbox: { EmailAddress: res },
              };
          })
        : null;
    const bodyContent: BodyContentType = { Value: body };

    const calendarItem: SerializableCalendarEvent = {
        RequiredAttendees: required || [],
        OptionalAttendees: optional || [],
        Locations: enhancedLocation ? [enhancedLocation] : [],
        Resources: convertedResources || [],
        Subject: subject,
        Body: bodyContent,
        Start: startTime,
        End: endTime,
    };

    popoutCalendarCompose(calendarItem, 'Mail_AddIns', AddPopoutSource.Addins);
};
